'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = 'M568 16C439.2 16 328.2 92.1 277.4 201.8c-3.9-3.9-8.1-7.6-12.5-11C319.1 77.9 434.5 0 568 0c4.4 0 8 3.6 8 8s-3.6 8-8 8zM447.8 292l-.4-.1c-.9-8.7-2.9-17.1-5.7-25C466.2 222.2 513.6 192 568 192c4.4 0 8 3.6 8 8s-3.6 8-8 8c-55.2 0-102.3 35-120.2 84zm-76-94.1C415.2 136.2 486.9 96 568 96c4.4 0 8 3.6 8 8s-3.6 8-8 8c-74.4 0-140.4 36.3-181.1 92.2c-4.8-2.5-9.9-4.6-15.1-6.4zm27 119c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 228.8 212.9 208 176 208c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.8c1.5 7.9-3.1 15.6-10.7 18.2C39 350.5 16 380.6 16 416c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-.4 0-.9 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 192c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 230.2 317.6 224 336 224c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96L96 512c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 318.1 64 311.1 64 304c0-61.9 50.1-112 112-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;